import {
  ApolloProvider as Provider,
  ApolloClient as Client,
  InMemoryCache,
  HttpLink,
  ApolloLink,
  split,
} from '@apollo/client';
import { GraphQLWsLink } from '@apollo/client/link/subscriptions';
import { createClient } from 'graphql-ws';
import { getMainDefinition } from '@apollo/client/utilities';
import { loadErrorMessages, loadDevMessages } from '@apollo/client/dev';

if (process.env.NODE_ENV !== 'production') {
  loadDevMessages();
  loadErrorMessages();
}

const httpLink = new HttpLink({
  uri: process.env.REACT_APP_BASE_URL,
  headers: {
    Authorization: `Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MiwiaWF0IjoxNzM3NTI4NTA5LCJleHAiOjE3Mzc1NzE3MDl9.GTSwpFkndhb5nPRJ2pl2ehqxZaIv7zsYvNXmgY_DvJc`,
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    'Access-Control-Allow-Methods': 'GET, POST, PUT, DELETE, OPTIONS',
    'Access-Control-Allow-Headers': 'Content-Type, Authorization ',
  },
  credentials: 'same-origin',
});

const authLink = new ApolloLink((operation, forward) => {
  const token = localStorage.getItem('jwt_access_token');
  const operatorId = localStorage.getItem('operatorId');
  const driverPermissions = localStorage.getItem('driverPermissions');
  const orderPermissions = localStorage.getItem('orderPermissions');
  const financePermissions = localStorage.getItem('financePermissions');
  const tariffPermissions = localStorage.getItem('tariffPermissions');
  const communicationsPermissions = localStorage.getItem('communicationsPermissions');
  operation.setContext({
    headers: {
      authorization: token ? `Bearer ${token}` : '',
      'X-Operator-ID': operatorId || '',
      'X-Driver-Permissions': driverPermissions,
      'X-Order-Permissions': orderPermissions,
      'X-Finance-Permissions': financePermissions,
      'X-Tariff-Permissions': tariffPermissions,
      'X-Communications-Permissions': communicationsPermissions,
    },
  });
  return forward(operation);
});

const wsLink = new GraphQLWsLink(
  createClient({
    url: 'ws://172.16.100.25:3010/',
  })
);

const splitLink = split(
  ({ query }) => {
    const definition = getMainDefinition(query);
    return definition.kind === 'OperationDefinition' && definition.operation === 'subscription';
  },
  wsLink,
  httpLink
);

const client = new Client({
  link: authLink.concat(splitLink),
  cache: new InMemoryCache({}),
});

export const ApolloProvider = ({ children }) => {
  return <Provider client={client}>{children}</Provider>;
};

export default client;
